import { createContext, useContext } from 'react'

import type { NavGroup } from './types'

export type NavLinkRenderer = (props: {
  to: string
  className?: string
  onClick?: () => void
  children: React.ReactNode
}) => React.ReactNode

export type NavPins = {
  has: (url: string) => boolean
  toggle: (url: string) => void
}

type Shell = {
  groups: NavGroup[]
  currentUrl: string
  renderLink: NavLinkRenderer
  pins?: NavPins | undefined
}

export const ShellContext = createContext<Shell | null>(null)

export function useShell() {
  const shell = useContext(ShellContext)
  if (!shell) throw new Error('useShell must be used within an AppShell')
  return shell
}
